<template>
  <RModal
    ref="modal"
    :persistent="false"
    title="Create new order"
    max-width="350px"
    max-height="auto"
    full-size
    @hide="closeModal"
    @ok="onSave"
    @cancel="$event()"
  >
    <Grid class="q-pt-md" gap="var(--r-space-md)">
      <FileUploader v-model="formData.file" stack-label="Order file" />

      <RInput
        v-model="formData.member_purchase_order_reference"
        :disable="disable('member_purchase_order_reference')"
        label="Purchase order reference"
        no-feedback-icon
        no-hint
      />

      <RInput
        id="amount"
        :value="formattedAmount"
        label="Amount"
        no-feedback-icon
        no-hint
        on-clear="focus"
        @clear="clearAmount"
      />

      <RInput v-model="formData.date" :disable="disable('date')" label="Date" is-date no-feedback-icon no-hint />
    </Grid>
  </RModal>
</template>
<script>
import * as apiTo from '@/modular-api'
import { cleaveInstance } from '@/utils/cleave-instance'
import { cloneDeep } from 'lodash'
import { LmFormObject } from '@lib/models/lm-form-object.class'
// Components
import RModal from '@/ui/RModal'
import FileUploader from '@/reusable/FileUploader/FileUploader'

export default {
  components: {
    RModal,
    FileUploader
  },

  props: {
    showing: {
      type: Boolean,
      default: false
    },
    disableProperties: {
      type: Array,
      default: () => []
    },
    entity: {
      type: Object,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      formattedAmount: null,
      formData: {},
      dataTemplate: {
        member_purchase_order_reference: null,
        file: null,
        date: null,
        amount: null
      },
      created: false,
      amountCleave: null
    }
  },

  computed: {
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    }
  },

  watch: {
    showing: {
      immediate: true,
      handler(newVal) {
        if (newVal) this.showModal()
      }
    }
  },

  created() {
    this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
  },

  methods: {
    showModal() {
      this.$refs.modal.show()
      this.$nextTick(() => {
        this.amountCleave = cleaveInstance.call(this, '#amount .input-component .q-field__native', ({ target }) => {
          this.formData.amount = target.rawValue || null
          this.formattedAmount = target.value || null
        })
      })
    },

    formatData() {
      let data = cloneDeep(this.formData)
      delete data.errors
      delete data.originalData
      if (!data.file) delete data.file
      data.date = this.formatDateForPost(this.formData.date, this.settings.date_format)
      data.amount = data.amount ? Number(data.amount) : null
      let formData = new FormData()
      this.formData.getFormData(formData, data)
      return formData
    },

    onSave(hide, setLoading) {
      setLoading(true)

      apiTo
        .CREATE_ADDITIONAL_ORDER_FOR_ENTITY(this.namespace, this.entity.id, this.formatData())
        .then(() => {
          this.$emit('refresh')
          this.closeModal()
          hide()
        })
        .finally(() => setLoading(false))
    },

    closeModal() {
      this.$emit('close')
      this.created = false
      this.clearAmount()
      this.$set(this, 'formData', new LmFormObject(this.dataTemplate))
    },

    disable(key) {
      return this.disableProperties.includes(key)
    },

    clearAmount() {
      this.amountCleave.setRawValue(null)
    }
  }
}
</script>
